import { Chip, Typography } from "@material-tailwind/react";
import { t } from "i18next";
import OdooFieldMappingAdminActions from "./OdooFieldMappingAdminActions";

interface OdooFieldMappingListItemProps {
  mapping: EasyTech.Odoo.FieldMapping;
  isLast?: boolean;
  onChange: () => void;
}

export default function OdooFieldMappingListItem({
  mapping,
  isLast = false,
  onChange
}: OdooFieldMappingListItemProps) {
  const getTypeColor = (type: EasyTech.Odoo.FieldType): "green" | "blue" | "amber" | "purple" | "blue-gray" => {
    switch (type) {
      case "BOOLEAN":
        return "green";
      case "STRING":
        return "blue";
      case "INTEGER":
      case "DECIMAL":
        return "amber";
      case "DATE":
        return "purple";
      default:
        return "blue-gray";
    }
  };

  const getTypeLabel = (type: EasyTech.Odoo.FieldType): string => {
    switch (type) {
      case "BOOLEAN":
        return t("admin:odoo.types.BOOLEAN", "Booléen");
      case "STRING":
        return t("admin:odoo.types.STRING", "Texte");
      case "INTEGER":
        return t("admin:odoo.types.INTEGER", "Entier");
      case "DECIMAL":
        return t("admin:odoo.types.DECIMAL", "Décimal");
      case "DATE":
        return t("admin:odoo.types.DATE", "Date");
      default:
        return type;
    }
  };

  return (
    <tr className={`page-list-item ${isLast ? "last" : ""}`}>
      {/* Paramètre EasyTech */}
      <td>
        <div className="flex flex-col">
          <Typography className="font-semibold text-gray-900 text-sm">
            {mapping.label}
          </Typography>
          <code className="text-xs text-gray-500 font-mono">
            {mapping.fieldKey}
          </code>
        </div>
      </td>

      {/* Nom technique dans Odoo */}
      <td>
        <div className="flex items-center gap-1.5">
          {mapping.odooField ? (
            <code className="bg-gray-100 text-purple-700 px-2 py-0.5 rounded text-xs font-mono font-medium border border-gray-200">
              {mapping.odooField}
            </code>
          ) : (
            <span className="text-xs text-gray-400 italic">
              {t("admin:odoo.notConfigured", "Non configuré")}
            </span>
          )}
        </div>
      </td>

      {/* Type de données */}
      <td>
        <Chip
          size="sm"
          variant="ghost"
          color={getTypeColor(mapping.fieldType)}
          value={getTypeLabel(mapping.fieldType)}
          className="capitalize font-medium text-xs w-fit py-0.5 px-2"
        />
      </td>

      {/* Description */}
      <td>
        <Typography className="text-sm text-gray-600 max-w-xs truncate" title={mapping.description}>
          {mapping.description || "-"}
        </Typography>
      </td>

      {/* Actions */}
      <td>
        <OdooFieldMappingAdminActions mapping={mapping} onChange={onChange} />
      </td>
    </tr>
  );
}
